import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { PaginationInstance } from 'ngx-pagination';
import { ToastrService } from 'ngx-toastr';
import { PartnerService } from 'src/app/services/partner.service';

@Component({
  standalone: false,
  selector: 'app-corporate-deals-list',
  templateUrl: './corporate-deals-list.component.html',
})
export class CorporateDealsListComponent implements OnInit {
  items: any[] = [];
  paginationConfig: PaginationInstance = {
    id: 'corporate_deals_listing',
    itemsPerPage: 10,
    totalItems: 0,
    currentPage: 1,
  };

  constructor(
    private partnerService: PartnerService,
    private toaster: ToastrService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.loadItems();
  }

  loadItems(): void {
    this.partnerService.list().subscribe({
      next: (partners) => {
        this.items = partners;
        this.paginationConfig.totalItems = this.items.length;
        this.clampPage();
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.toaster.error(error?.error?.message || 'Failed to load corporate deals.');
      },
    });
  }

  onPageChange(page: number): void {
    this.paginationConfig.currentPage = page;
  }

  statusLabel(status: number): string {
    return status === 1 ? 'Active' : status === 2 ? 'Inactive' : String(status ?? '-');
  }

  private clampPage(): void {
    const perPage = this.paginationConfig.itemsPerPage || 10;
    const maxPage = Math.max(1, Math.ceil((this.paginationConfig.totalItems ?? 0) / perPage));
    const current = this.paginationConfig.currentPage ?? 1;
    this.paginationConfig.currentPage = Math.min(Math.max(1, current), maxPage);
  }
}
